import React from 'react';
import styles from './Toast.module.css';
import { useToast } from '../../store/ToastContext';
import { CheckCircleIcon, XCircleIcon, AlertCircleIcon, InfoIcon, XIcon } from '../Icons';
import { classNames } from '../../utils/helpers';

const icons = {
  success: CheckCircleIcon,
  error: XCircleIcon,
  warning: AlertCircleIcon,
  info: InfoIcon,
};

function Toast() {
  const { toasts, removeToast } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className={styles.container}>
      {toasts.map((toast) => {
        const Icon = icons[toast.type] || InfoIcon;
        return (
          <div
            key={toast.id}
            className={classNames(styles.toast, styles[toast.type])}
          >
            <Icon className={styles.icon} />
            <span className={styles.message}>{toast.message}</span>
            <button
              className={styles.close}
              onClick={() => removeToast(toast.id)}
            >
              <XIcon size={14} />
            </button>
          </div>
        );
      })}
    </div>
  );
}

export default Toast;
